import React from 'react';
import {
  Redirect, Route, Switch,
} from 'react-router-dom';
import AddNewCard from '../pages/addNewCard';
import CardInformation from '../pages/cardInfo';
import CardLicenseAndStatus from '../pages/cardLicenseAndStatus';
import ReassignEID from '../pages/reassigneId';
import UserInfo from '../pages/userInfo';

function PowerUserRoute() {
  return (
    <Switch>
      <Route exact path="/reassign-eid" name="ReassigneId" component={ReassignEID} />

      <Route exact path="/card-license" name="CardLicenseAndStatus" component={CardLicenseAndStatus} />
      <Route exact key="card-information" path="/card-information/:id" name="CardInformation" component={CardInformation} />
      <Route exact key="add-new-card" path="/add-new-card" name="AddNewCard" component={AddNewCard} />

      <Route exact key="my-profile" path="/my-profile" name="UserInfo" component={UserInfo} />
      <Redirect from="/" to="/reassign-eid" />
    </Switch>
  );
}

export default PowerUserRoute;
